import React from 'react'
import Box from '../../components/box';
import Carousel from '../../components/carousel';

interface StudioGalleryProps {
  studioPictureUrls: string[]
}

const StudioGallery: React.FC<StudioGalleryProps> = ({
  studioPictureUrls
}) => {
  return (
    <Box display={'block'}>
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        infiniteLoop
        dynamicHeight={false}
        autoPlay
        width={'100%'}
        interval={10000}
      >
        {studioPictureUrls.map((url) => (
          <Box key={url} width={'100%'} height={'40vh'}>
            <img src={url} alt='studio' style={{
              width: '100%',
              aspectRatio: '4/3',
              objectFit: 'cover',
              borderRadius: '12px'
            }} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}

export default StudioGallery
